import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../services/api';

export interface Municipality {
    id: string;
    name: string;
    slug: string;
    image: string;
    history?: string;
    contact_address?: string;
    contact_phone?: string;
    contact_email?: string;
    contact_hours?: string;
    map_iframe?: string;
    team?: { name: string; role: string; phone?: string; image?: string }[];
    access_username?: string;
    access_password?: string;
    has_access_password?: boolean;
}

export const useMunicipalities = () => {
    return useQuery<Municipality[]>({
        queryKey: ['municipalities'],
        queryFn: async () => {
            const { data: municipalitiesList } = await api.get('/municipalities');
            return municipalitiesList;
        },
    });
};

export const useMunicipality = (idOrSlug: string) => {
    return useQuery<Municipality>({
        queryKey: ['municipalities', idOrSlug],
        queryFn: async () => {
            const { data: municipalityDetail } = await api.get(`/municipalities/${idOrSlug}`);
            return municipalityDetail;
        },
        enabled: !!idOrSlug,
    });
};

export const useSaveMunicipality = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (municipality: Partial<Municipality>) => {
            if (municipality.id) {
                return api.put(`/admin/municipalities`, municipality);
            }
            return api.post(`/admin/municipalities`, municipality);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['municipalities'] });
        },
    });
};
export const useDeleteMunicipality = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (id: string) => {
            return api.delete(`/admin/municipalities?id=${id}`);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['municipalities'] });
        },
    });
};
